import React, { useState, useRef, useEffect, useContext } from "react";
import styles from "./GroupPhotos.module.scss";
import TinySlider from "tiny-slider-react";
import SliderControls from "./SliderButton";
import sliderStyles from "./TinySlider.module.scss";
import { animOnSwipe } from "../utils/animation";
import { getBoundingClientRect } from "../utils/helpers";
import { isMobile, isTablet } from "react-device-detect";
import ReactGA from "react-ga4";
import { Context } from "../Store";
import Dots from "./Dots";
import useSliderDots from "../hooks/useSliderDots";
import ShareArrow from "./ShareArrow";

const GroupPhotos = (props) => {
  const [state] = useContext(Context);
  const sliderRef = useRef();

  const maxDots = 2;
  const { currentIndex, visibleDots, goToSlide } = useSliderDots(sliderRef, state.photos.length, maxDots);

  const settings = {
    lazyload: true,
    touch: true,
    nav: false,
    controlsContainer: "." + styles.sliderContainer + " .sliderControls",
    mouseDrag: true,
    loop: false,
    items: 1,
    gutter: 0,
    edgePadding: 0,
    responsive: {
      640: {
        items: state.photos.length < 2 ? state.photos.length : 2,
        gutter: 5,
        edgePadding: 0,
      },
      1024: {
        items: state.photos.length < 3 ? state.photos.length : 3,
        gutter: 5,
        edgePadding: 0,
      },
    },
  };

  let groupPhotoSources = state.photos.map((photo) => {
    return state.bloburl + "/groupphotos/" + photo.asset_uri;
  });
  let groupPhotoMedia = state.photos.map((photo) => {
    //console.log(photo)
    return {
      mediaType: "PHOTO",
      mediaURI: photo.asset_uri,
      downloadURI: state.bloburl + "/groupphotos/" + photo.asset_uri,
      sectionName: "Group Photo",
    };
  });

  useEffect(() => {
    animOnSwipe(sliderRef.current.slider);
  }, [sliderRef]);

  const handleHover = (index, e) => {
    let perviewDetails = {
      section: "GroupPhoto",
      index: index,
      ...groupPhotoMedia[index],
      target: e.currentTarget.querySelector("img"),
      timeStamp: e.timeStamp,
      groupLength: groupPhotoMedia.length,
      sources: groupPhotoSources,
      mediashare: groupPhotoMedia,
      type: "image",
    };
    props.handleHover(perviewDetails, e.type);
  };

  const openLightbox = (index) => {
    let lightboxDetails = {
      section: "GroupPhoto",
      index: index,
      sources: groupPhotoSources,
      mediashare: groupPhotoMedia,
      type: "image",
    };
    props.openLightbox(lightboxDetails);
  };

  const showDots =
    ((isMobile || isTablet) && state.photos.length > 1) || (!isMobile && !isTablet && state.photos.length > 3);

  return (
    <div
      id="group-photos"
      className={`section scale-slider section--with-share-arrow ${showDots ? "section--padded-extra" : "section--padded"}`}
    >
      <h2>The Group Shot</h2>
      <p className="subheading">Proof you were all here.</p>
      <div className={styles.sliderContainer}>
        <SliderControls slider={sliderRef}></SliderControls>

        <TinySlider settings={settings} ref={sliderRef}>
          {state.photos.map((photo, index) => (
            <div
              key={index}
              style={{ position: "relative" }}
              className={[sliderStyles.slide, styles.groupPhotoItem].join(" ")}
            >
              <div
                onClick={() => openLightbox(index)}
                onMouseEnter={isMobile ? () => false : handleHover.bind(this, index)}
                onMouseLeave={handleHover.bind(this, index)}
                style={{ cursor: "pointer" }}
              >
                <img src={state.bloburl + "/groupphotos/" + photo.asset_uri} alt="" />
              </div>

              <ShareArrow
                title={`Flight Club Stories - Group Photo`}
                url={state.bloburl + "/groupphotos/" + photo.asset_uri}
                text={"Check out this group photo from our Flight Club visit."}
                downloadUrl={state.bloburl + "/groupphotos/" + photo.asset_uri}
                isVideo={false}
                customBottom="-30px"
                sectionName="Group Photo"
                mediaShare={{
                  mediaType: "PHOTO",
                  mediaURI: photo.asset_uri,
                  downloadURI: state.bloburl + "/groupphotos/" + photo.asset_uri,
                  sectionName: "Group Photo",
                }}
                cityurl={state.cityurl}
                venue={state.venue}
                guid={state.guid}
                country={state.country}
              />
            </div>
          ))}
        </TinySlider>

        {/* Conditionally show dots */}
        {showDots && <Dots visibleDots={visibleDots} currentIndex={currentIndex} goToSlide={goToSlide} />}
      </div>
    </div>
  );
};

export default GroupPhotos;
